import { useState, useEffect, useCallback } from 'react';
import apiService from '../services/api';
import logger from '../services/logger';

export const useContent = () => {
  const [content, setContent] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAllContent = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await apiService.getAllContent();
      
      if (response.success) {
        setContent(response.data);
        logger.info('Content loaded successfully', { contentTypes: Object.keys(response.data) });
      } else {
        throw new Error(response.message || 'Failed to load content');
      }
    } catch (err) {
      logger.error('Error loading content', { error: err.message });
      setError(err.message);
      // Set fallback content
      setContent({
        about_us: {
          title: 'About Us',
          content: 'Welcome to RadioStreamIn.com - Your gateway to global radio stations.'
        },
        privacy_policy: {
          title: 'Privacy Policy',
          content: 'We respect your privacy and are committed to protecting your personal information.'
        }
      });
    } finally {
      setLoading(false);
    }
  }, []);

  const getContentByType = useCallback((contentType) => {
    return content[contentType] || {
      title: contentType.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase()),
      content: 'Content not available.'
    };
  }, [content]);

  useEffect(() => {
    fetchAllContent();
  }, [fetchAllContent]);

  return {
    content,
    loading,
    error,
    getContentByType,
    refetch: fetchAllContent
  };
};
